<!-- Header -->
<div class="navigation-wrapper">
  <div class="secondary-navigation-wrapper">
    <div class="container">
      <div class="navigation-contact float-left">
        <span style="font-size: large">
            <a href="https://ruh.ac.lk">University of Ruhuna, Sri Lanka</a>
        </span>
      </div>
      <form name="search">
      <div class="search search-field">
        <div class="input-group">
            <input type="search" class="form-control" name="search" placeholder="Search" name="search" id="search" (keyup)="siteSearch($event)">
            <span class="input-group-btn">
              <button type="submit" id="search-submit" class="btn" (click)="siteSearch($event)">
              <i class="fa fa-search"></i></button></span>
        </div><!-- /.input-group -->
      </div>
      </form>
      <ul class="secondary-navigation list-unstyled custom-topbar top-links">
        <li>
          <a routerLink="/allinfo">Events</a>
        </li>
        <li>
          <a routerLink="/allnews">News</a>
        </li>
        <li>
          <a routerLink="/otherinfo/3">Notices</a>
        </li>
        <li>
          <a routerLink="/otherinfo/4">Vacancies</a>
        </li>
        <li>
          <a routerLink="/contact">Contact
<!--            <span class="input-group-btn"><i class="fa fa-phone"></i></span>-->
          </a>
        </li>
      </ul>
    </div>
  </div><!-- /.secondary-navigation -->
  <div class="primary-navigation-wrapper">
    <header class="navbar navbar-expand-lg sticky-top" id="top" role="banner" >
      <div class="container">
        <div class="navbar-header">
         <button class="navbar-toggle" type="button" data-toggle="collapse" data-target=".bs-navbar-collapse" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
         </button>
          <div class="wow fadeInLeft animated">
            <div class="navbar-brand nav" id="brand">
              <a href="index.html"><img src="assets/img/logo.png" alt="brand"></a>
            </div>
          </div>
        </div>
        <nav class="collapse navbar-collapse bs-navbar-collapse" role="navigation" [ngbCollapse]="toggleNavbar">
          <ul class="navbar-nav ml-auto">
            <li class="active">
              <a href="#" class="no-link" (click)="hideMenu()">Home</a>
            </li>
            <li>
              <a routerLink="about" class=" has-child no-link" (mouseover)="toggleNavbar = false">About</a>
              <ul class="list-unstyled child-navigation" [ngbCollapse]="toggleNavbar">
                <li><a routerLink="/about" (click)="hideMenu()">Overview</a></li>
                <li><a routerLink="/deanmassage" (click)="hideMenu()">Message from Dean</a></li>
                <li><a (click)="navigatePage('department', 'DEAN','15')" (click)="hideMenu()">Deans Office</a></li>
                <li><a routerLink="contact" (click)="hideMenu()">Contact us</a></li>
<!--                <li class="dropdown dropdown-submenu second-level-menu-wrapper"><a href="#" class="dropdown-toggle" data-toggle="dropdown">Dropdown Submenu Link 5.4</a>-->
<!--                  <ul class="dropdown-menu second-level-menu">-->
<!--                     <li class="kopie"><a href="#">Dropdown Submenu Link 5.4</a></li>-->
<!--                    <li><a href="#">Dropdown Submenu Link 5.4.1</a></li>-->
<!--                    <li><a href="#">Dropdown Submenu Link 5.4.2</a></li>-->
<!--                  </ul>-->
<!--                </li>-->
              </ul>
            </li>
            <li>
              <a href="#" class="has-child no-link" (mouseover)="toggleNavbar = false">Departments & Units</a>
              <ul class="list-unstyled child-navigation mega-menu" [ngbCollapse]="toggleNavbar">
<!--                <li *ngFor="let dept of departmentData let i=index">-->
<!--                  <a (click)="navigatePage('department', dept.id)">{{dept.dept_type}}</a>-->
<!--                </li>-->

                <div class="row ">
                  <div class="column-{{departmentData.length}} second" *ngFor="let dept of departmentData">
                    <li><a>{{dept.dept_type}}</a></li>

                    <li *ngFor="let department of dept.dept_data">
                      <a (click)="hideMenu()" (click)="navigatePage('department', department.code, department.id, department.external_url)">{{department.dept_name}} - ({{department.code}})</a>
                    </li>

                  </div>
                </div>
              </ul>
            </li>

            <li>
              <a href="#" class="has-child no-link" (mouseover)="toggleNavbar = false">Student</a>
              <ul class="list-unstyled child-navigation" [ngbCollapse]="toggleNavbar">
                <li class="dropdown dropdown-submenu second-level-menu-wrapper">
                  <a href="#" data-toggle="dropdown">HandBook</a>
                  <ul class="dropdown-menu second-level-menu">
                    <li><a (click)="navigateUrl('https://hss.ruh.ac.lk/HandBook2024/student_handbook_2024.pdf')">Handbook 2023/2024</a></li>
                    <li><a (click)="navigateUrl('https://hss.ruh.ac.lk/HandBook2023/Student_Handbook_2022_2023.pdf')">Handbook 2022/2023</a></li>
                    <li><a (click)="navigateUrl('https://hss.ruh.ac.lk/HandBook2022/Handbook_2021-2022.pdf')">Handbook 2021/2022</a></li>
                    <li><a (click)="navigateUrl('https://hss.ruh.ac.lk/HandBook2021/Handbook_2020-2021.pdf')">Handbook 2020/2021</a></li>
                    <li><a (click)="navigateUrl('https://hss.ruh.ac.lk/HandBook2020/StudentHandbook2020.pdf')">Handbook 2019/2020</a></li>
                    <li><a (click)="navigateUrl('https://hss.ruh.ac.lk/studenthandbook2019.pdf')">Handbook 2018/2019</a></li>
                    <li><a (click)="navigateUrl('https://hss.ruh.ac.lk/StudentHandbook2017.pdf')">Handbook 2016/2017</a></li>
                  </ul>
                <li class="dropdown dropdown-submenu second-level-menu-wrapper">
                  <a href="#" data-toggle="dropdown">Student Services</a>
                  <ul class="dropdown-menu second-level-menu">
                    <li><a (click)="hideMenu()" routerLink="/counselling">Counselling & Mentoring</a></li>
                    <li><a (click)="navigateUrl('https://eugc.ac.lk/rag/')">Ragging Complaints</a></li>
                    <li><a (click)="navigateUrl('https://hss.ruh.ac.lk/complains/')" target="_blank">Grievances</a></li>
                  </ul>
                <li class="dropdown dropdown-submenu second-level-menu-wrapper">
                  <a href="#" data-toggle="dropdown">Student Societies</a>
                  <ul class="dropdown-menu second-level-menu">
                    <li><a (click)="hideMenu()" routerLink="/association-of-pali-and-buddhist-studies">Association of Pali and Buddhist Studies</a></li>
                    <li><a (click)="navigateUrl('https://erfuor.wixsite.com/erforum')">Environmental Researchers' Forum</a></li>
                    <li><a (click)="hideMenu()" routerLink="/geographical-environmental-science-society">Geographical and Environmental Science Society</a></li>
                    <li><a (click)="hideMenu()" routerLink="/public-policy-society">Public Policy Society</a></li>
                    <li><a (click)="hideMenu()" routerLink="/economics-and-social-statistics-society">Society of Economics and Social Statistics</a></li>
                    <li><a (click)="hideMenu()" routerLink="/sociological-association">Sociological Association</a></li>
                    <li><a (click)="hideMenu()" routerLink="/history_archaeology_students_society">History and Archaeology Students' Society</a></li>
                  </ul>
                <li class="dropdown dropdown-submenu second-level-menu-wrapper">
                  <a href="#" data-toggle="dropdown">University Services</a>
                  <ul class="dropdown-menu second-level-menu">
                    <li><a (click)="navigateUrl('https://cgu.ruh.ac.lk/')">Career Guidance Unit (CGU)</a></li>
                    <li><a (click)="navigateUrl('https://www.lib.ruh.ac.lk/web/index.php')">Library</a></li>
                    <li><a (click)="navigateUrl('https://adm.ruh.ac.lk/medicalcenter/')">Medical Centre</a></li>
                    <li><a (click)="navigateUrl('https://adm.ruh.ac.lk/physicaledu/')">Physical Education</a></li>
                  </ul>
                </li>
                <li class="dropdown dropdown-submenu second-level-menu-wrapper">
                  <a href="#" data-toggle="dropdown">Distance and Continuing Education</a>
                  <ul class="dropdown-menu second-level-menu">
                    <li><a (click)="navigateUrl('http://www.dceu.ruh.ac.lk/BA_Degree/BADegree.php')">Bachelor of Arts General (External) Degree</a></li>
                    <li><a (click)="navigateUrl('http://www.dceu.ruh.ac.lk/english/')">Extension Courses in English</a></li>
                    <li><a (click)="navigateUrl('http://www.dceu.ruh.ac.lk/Dip_Psychological_Counseling/index.php')">Diploma in Psychological Counseling</a></li>
                  </ul>
                </li>
              </ul>
            </li>

            <li>
              <a href="#" class="has-child no-link" (mouseover)="toggleNavbar = false">Research</a>
              <ul class="list-unstyled child-navigation" [ngbCollapse]="toggleNavbar">
                <li><a (click)="hideMenu()" routerLink="/research-center">Faculty Research Centre</a></li>
                <li><a (click)="hideMenu()" routerLink="/research-committee">Faculty Research Committee</a></li>
                <li><a (click)="hideMenu()" routerLink="/ethics-review-committee">Ethics Review Committee</a></li>
                <li><a (click)="hideMenu()" routerLink="/research">Staff Publications</a></li>
              </ul>
            </li>

            <li>
              <a href="#" class="has-child no-link">Publications</a>
              <ul class="list-unstyled child-navigation">
                    <li><a (click)="navigateUrl('https://hss.ruh.ac.lk/JFHSS/index.html')">Journal of the Faculty of Humanities and Social Sciences</a></li>
                    <li><a (click)="navigateUrl('https://www.hss.ruh.ac.lk/JSSHR/index.html')">Journal of Social Sciences and Humanities Review</a></li>
              </ul>
            </li>

            <li>
              <a href="#" class="has-child no-link" (mouseover)="toggleNavbar = false">Conference</a>
              <ul class="list-unstyled child-navigation" [ngbCollapse]="toggleNavbar">
                <li><a (click)="navigateUrl('https://rasas.fohss.lk')">RASAS</a></li>
                <li><a (click)="navigateUrl('https://hss.ruh.ac.lk/ruichss')">RUICHSS</a></li>
                <li class="dropdown dropdown-submenu second-level-menu-wrapper">
                  <a href="#" data-toggle="dropdown">ARCHIEVE</a>
                  <ul class="dropdown-menu second-level-menu">
                    <li><a (click)="navigateUrl('https://hss.ruh.ac.lk/rasas/RASAS2021/index.html')">RASAS 2021</a></li>
                    <li><a (click)="navigateUrl('https://hss.ruh.ac.lk/ruichss/ruichss2020/')">RUICHSS 2020</a></li>
                    <li><a (click)="navigateUrl('https://hss.ruh.ac.lk/rasas/RASAS2020/index.html')">RASAS 2020</a></li>
                    <li><a (click)="navigateUrl('https://hss.ruh.ac.lk/ruichss2019/')">RUICHSS 2019</a></li>
                    <li><a (click)="navigateUrl('https://www.hss.ruh.ac.lk/rasas2019/index.html')">RASAS 2019</a></li>
                    <li><a (click)="navigateUrl('https://hss.ruh.ac.lk/rasas2018/index.html')">RASAS 2018</a></li>
                    <li><a (click)="navigateUrl('https://www.hss.ruh.ac.lk/ruichss/index.php')">RUICHSS 2018</a></li>
                    <li><a (click)="navigateUrl('https://hss.ruh.ac.lk/rasas2017/index.html')">RASAS 2017</a></li>
                    <li><a (click)="navigateUrl('hhttps://hss.ruh.ac.lk/icprd/index.html')">ICPRD 2016</a></li>
                    <li><a href="#">RASAS 2016</a></li>
                    <li><a (click)="navigateUrl('https://hss.ruh.ac.lk/ruichss2017/index.html')">RUICHSS 2017</a></li>
                    <li><a (click)="navigateUrl('https://hss.ruh.ac.lk/icpst/index.html')">ICPST 2015</a></li>
                  </ul>
                </li>
              </ul>
            </li>

            <li>
              <a href="#" class="has-child no-link" (mouseover)="toggleNavbar = false">Staff</a>
              <ul class="list-unstyled child-navigation" [ngbCollapse]="toggleNavbar">
                <li *ngFor="let staff of staffCategoryData let i=index">
                  <a (click)="hideMenu()" routerLink="/allstaff/{{staff.category}}/{{staff.id}}">{{staff.category}}</a>
                </li>
              </ul>
            </li>

            <li>
              <a href="#" class="has-child no-link" (mouseover)="toggleNavbar = false">Collaborations</a>
              <ul class="list-unstyled child-navigation" [ngbCollapse]="toggleNavbar">
                <li><a (click)="navigateUrl('https://hss.ruh.ac.lk/department/ENACT/20')">ENACT - Enhancing Governance, Management and Reform in Sri Lankan Universities through Non-Academic Staff Training</a></li>
                <li><a (click)="navigateUrl('https://hss.ruh.ac.lk/department/INCEDU/19')">IncEdu - Developing Inclusive Education for Students with Disabilities in Sri Lankan Universities</a></li>
                <li><a (click)="navigateUrl('https://cpdsruhuna.wordpress.com')">NORHED - Norwegian Programme for Capacity Development in Higher Education and Research for Development</a></li>
              </ul>
            </li>

            <li>
              <a routerLink="/faq" class="no-link" (click)="hideMenu()">FAQ</a>
            </li>

          </ul>
        </nav><!-- /.navbar collapse-->
      </div><!-- /.container -->
    </header><!-- /.navbar -->
  </div><!-- /.primary-navigation -->
  <div class="background">
    <img src="assets/img/background-city.png"  alt="background">
  </div>
</div>



